import { useMemo } from 'react'
import { Row } from 'react-table'
import reduce from 'lodash/reduce'
import uniq from 'lodash/uniq'

import { ProgramMeetingType } from '../types'

export const useMentorshipMeetingsSummary = (rows: Row<any>[]) =>
  useMemo(() => {
    const { meetingCount, momentCount, totalMeetingTime, positiveFeedbackCount, negativeFeedbackCount } = reduce(
      rows,
      (acc, { original: { type, duration, rating } }: Row<any>) => ({
        meetingCount:
          acc.meetingCount + (type === ProgramMeetingType.meeting || type === ProgramMeetingType.moment ? 1 : 0),
        momentCount: acc.momentCount + (type === ProgramMeetingType.moment ? 1 : 0),
        totalMeetingTime: acc.totalMeetingTime + duration,
        positiveFeedbackCount:
          acc.positiveFeedbackCount + (rating.mentor === true ? 1 : 0) + (rating.mentee === true ? 1 : 0),
        negativeFeedbackCount:
          acc.negativeFeedbackCount + (rating.mentor === false ? 1 : 0) + (rating.mentee === false ? 1 : 0),
      }),
      {
        meetingCount: 0,
        momentCount: 0,
        totalMeetingTime: 0,
        positiveFeedbackCount: 0,
        negativeFeedbackCount: 0,
      },
    )
    const feedbackCount = positiveFeedbackCount + negativeFeedbackCount
    return {
      meetingCount,
      momentCount,
      matchesCount: uniq(rows.map(({ original: { matchId } }) => matchId)).length,
      averageMeetingTime: meetingCount ? Math.round(totalMeetingTime / meetingCount) : 0,
      positiveFeedbackPercent:
        (feedbackCount ? Math.round((positiveFeedbackCount / feedbackCount) * 10000) / 100 : 0) + '%',
      negativeFeedbackPercent:
        (feedbackCount ? Math.round((negativeFeedbackCount / feedbackCount) * 10000) / 100 : 0) + '%',
    }
  }, [rows])
